import React, { FC, useEffect } from 'react';
import { Button, Alert } from 'reactstrap';
import Popup from 'src/components/content/popup/popup';
import ContentWrapper from 'src/components/content/content-wrapper';
import ContentSection from 'src/components/content/content-section';
import warning from 'src/assets/icons/warning.svg';
import { trackReactivationViewed } from 'src/util/track';

import styles from './modal.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isReactivating: boolean;
  reactivateError: string;
  onConfirm: () => Promise<void>;
}

export const ReactivateAndPurchaseModal: FC<Props> = ({
  isOpen,
  onClose,
  isReactivating,
  reactivateError,
  onConfirm,
}) => {
  useEffect(() => {
    if (isOpen) {
      trackReactivationViewed('signup_extras');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Popup onClose={onClose}>
      <ContentWrapper className={styles.background} collapseAt="sm">
        <ContentSection className={styles.confirmContent} collapseAt="sm">
          <Button
            className={styles.close}
            onClick={onClose}
            disabled={isReactivating}
          />

          <div style={{ textAlign: 'center', marginBottom: '15px' }}>
            <img src={warning} alt={''} />
          </div>

          <div className={styles.title}>Reactivate Subscription?</div>

          <div className={styles.bodytext} style={{ textAlign: 'center' }}>
            You need to reactivate your main subscription to purchase this
            add-on. Reactivating will cancel your pending cancellation and
            resume your current billing cycle.
          </div>

          {reactivateError && (
            <Alert color="danger" style={{ marginBottom: '15px' }}>
              {reactivateError}
            </Alert>
          )}

          <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
            <Button
              outline
              style={{ flex: 1 }}
              onClick={onClose}
              disabled={isReactivating}>
              No, Go Back
            </Button>
            <Button
              style={{ flex: 1 }}
              onClick={onConfirm}
              disabled={isReactivating}>
              {isReactivating ? 'Reactivating...' : 'Yes, Reactivate'}
            </Button>
          </div>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
